import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';
import { useTheme } from '../../../context/ThemeContext';

const ThemeSwitcher = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="switcher">
      <InputSwitch
        checked={theme === 'dark'}
        onChange={toggleTheme}
        inputId="theme-switch"
        className="theme-switch-icon"
      />
    </div>
  );
};

export default ThemeSwitcher;
